/** @format */

import React from "react";
import cn from "classnames";
import moment from "moment/moment";
import { isMobile } from "react-device-detect";
import style from "./style.module.scss";
import CustomDatePicker from "../../shared/date-picker/Date";
import CalendarIcon from "../../shared/icons/CalendarIcon";
import CloseIconNew from "../../shared/icons/CloseIconNew";

const OrdersDatePicker = ({
  date,
  isEditable = false,
  minDate,
  setDate,
  detect,
  labelText = "",
  errorDate = "",
  placeholderText = "00.00.00",
}) => {
  const onChangeDate = (date) => {
    const dateWithZeroTime = new Date(date);
    dateWithZeroTime.setHours(0);
    dateWithZeroTime.setMinutes(0);
    dateWithZeroTime.setSeconds(0);

    setDate(dateWithZeroTime);
    if (detect) detect();
  };

  const ContentItemEditable = (type) => {
    let input = "";
    if (type === "date") {
      input = (
        <CustomDatePicker
          selected={date}
          dateFormat="dd.MM.yyyy"
          placeholderText={placeholderText}
          monthsShown={1}
          minDate={minDate}
          onChange={onChangeDate}
          withPortal={isMobile}
        />
      );
    }

    return input;
  };

  return (
    <>
      <div>
        <div
          className={cn("d-flex align-items-center justify-content-between", {
            [style.editable]: isEditable,
            [style.errorState]: errorDate,
          })}
        >
          <div className={cn(style.labelInp, { [style.labelError]: errorDate })}>
            {labelText}
          </div>
          <CalendarIcon />
          {isEditable ? ContentItemEditable("date") : ContentItem("date", date)}
          {date && <CloseIconNew onClick={() => setDate()} />}
        </div>
        {errorDate && <div className={style.errorText}>{errorDate}</div>}
      </div>
    </>
  );
};
const ContentItem = (type = "", value, prefixStart = "") => {
  let text = "";

  if (type === "date") {
    text = moment.utc(value).format("DD.MM.YYYY");
  }

  return (
    <span className="ms-1">
      {prefixStart}
      {text}
    </span>
  );
};

export default OrdersDatePicker;
